






import Vue from "vue";
import NovelDetail from "@/components/organisms/NovelDetail.vue";

export default Vue.extend({
  props: { novelId: String },
  components: { NovelDetail }
});
